import federalHolidays from '@18f/us-federal-holidays';
const normalizeToArray = (value) => (Array.isArray(value) ? value : [value]);
export const resolveExclusionDate = (rule, year) => {
    switch (rule.type) {
        case 'federal': {
            const allForYear = federalHolidays.allForYear(year);
            const match = allForYear.find((h) => h.name === rule.federalName)?.date;
            return match ? [match] : [];
        }
        case 'fixed': {
            const months = normalizeToArray(rule.month);
            const days = normalizeToArray(rule.day);
            return months.flatMap((m) => days.map((d) => new Date(year, m - 1, d)).filter((d) => d.getMonth() === m - 1));
        }
        case 'fixedDate': {
            const parsed = new Date(rule.date + 'T00:00:00');
            return isNaN(parsed.getTime()) ? [] : [parsed];
        }
        case 'nthWeekday': {
            const months = normalizeToArray(rule.month);
            const ns = normalizeToArray(rule.n);
            return months.flatMap((m) => ns
                .map((n) => n === 'last' ? getLastWeekdayOf(rule.weekday, m, year) : getNthWeekdayOf(n, rule.weekday, m, year))
                .filter((d) => d.getMonth() === m - 1));
        }
    }
};
const getNthWeekdayOf = (n, weekday, month, year) => {
    const firstOfMonth = new Date(year, month - 1, 1);
    const firstOccurrence = 1 + ((weekday - firstOfMonth.getDay() + 7) % 7);
    return new Date(year, month - 1, firstOccurrence + (n - 1) * 7);
};
const getLastWeekdayOf = (weekday, month, year) => {
    const lastDay = new Date(year, month, 0).getDate();
    const lastDayDate = new Date(year, month - 1, lastDay);
    const diff = (lastDayDate.getDay() - weekday + 7) % 7;
    return new Date(year, month - 1, lastDay - diff);
};
//# sourceMappingURL=resolve-exclusion-date.js.map